import { createPortal } from "react-dom"
import { Popup, useMap } from "react-leaflet"
import { useSelector, useDispatch } from "react-redux"
import { useState } from "react"
import { $authHost } from "../../http"
import React from "react"
import { statuses, translate } from "../controls/old/AccountingSheetTableControl";
import { useAuth } from "react-oidc-context"
import {
    Typography,
    Box,
    Tabs,
    Tab,
    Button,
    Card,
    CardContent,
    Paper,
    Stack,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Snackbar,
    Alert,
    TextField
} from "@mui/material";
import {
    Place as PlaceIcon,
    Save as SaveIcon,
    Cancel as CancelIcon,
    Share as ShareIcon
} from "@mui/icons-material";
import { setLayers } from "../../store/reducers/helpersReducer"
import { useEffect, useMemo, useCallback, useRef } from "react";
import { addPulseMarker } from "../controls/helpers"
import { selectAccountingsByPillarId, selectRulesMap } from "../../store/selectors/supervisionSelector"
import { selectTasksByObject } from "../../store/selectors/tasksSelector"
import { codeColors } from "../contents/AccountingSheetView"
import { fetchAccounting } from "../../store/reducers/stateReducer"
import SpecsTab from "./Common/SpecsTab"
import ImagesTab from "./PopupPillar/ImagesTab"
import MountedTab from "./PopupPillar/MountedTab"
import TaskTab from "./Common/TaskTab"
import RelatedObjectsPanel from "./Common/RelatedObjectsPanel"
import { addNotification } from "../../store/reducers/notificationSlice"


const TabPanel = ({ children, value, index }) => {
    return parseInt(value) === parseInt(index) && <Box sx={{ mt: 0.5 }}>{children}</Box>;
};

const types = {
    'pillar04': 'Опора 0,4кВ',
    'pillar10': 'Опора 10кВ',
    'pillar04_10': 'Опора 0,4-10кВ',
    'pillar04-10': 'Опора 0,4-10кВ',
    'pillar': 'Опора',
    'rlnd': 'РЛНД',
    'zvz': 'Комплект адаптеров ВЗ',
    'opn': 'Комплект ОПН',
    'runn': 'РУНН'
}

const PopupPillar04 = ({ mark }) => {
    console.log(mark)
    const map = useMap()
    const dispatch = useDispatch()
    const auth = useAuth()
    const [value, setValue] = useState(null);
    const valueRef = useRef(null)

    // Ключи для localStorage
    const STORAGE_KEYS = {
        TAB_INDEX: 'popupPillar_tabIndex',
        SEARCH_SPEC: 'popupPillar_searchSpec'
    };

    // Функции для работы с localStorage
    const saveToStorage = (key, value) => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.warn('Ошибка сохранения в localStorage:', error);
        }
    };

    const loadFromStorage = (key, defaultValue = null) => {
        try {
            const stored = localStorage.getItem(key);
            return stored ? JSON.parse(stored) : defaultValue;
        } catch (error) {
            console.warn('Ошибка загрузки из localStorage:', error);
            return defaultValue;
        }
    };

    // Обработчик изменения вкладки с сохранением в localStorage
    const handleTabChange = (event, newValue) => {
        setValue(newValue);
        saveToStorage(STORAGE_KEYS.TAB_INDEX, newValue);
    };
    const [images, setImages] = useState([]);
    const [spec, setSpec] = useState(null)
    const specs = useSelector(state => state.state.specs)
    const specs_new = useSelector(state => state.state.specs_new)
    const { pillars } = useSelector(state => state.state.electricity)
    const [mounted, setMounted] = useState(null)
    const [type, setType] = useState(null)
    const accountings = useSelector(state => selectAccountingsByPillarId(state, mark.fid))
    const rulesMap = useSelector(selectRulesMap)
    const [loadingImages, setLoadingImages] = useState(false)

    // Состояния для редактирования чекбоксов
    const [editedRows, setEditedRows] = useState({});
    const editedRowsRef = useRef({});
    const [hasRejectedRows, setHasRejectedRows] = useState(false)
    const [rejectionReason, setRejectionReason] = useState('');
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertSeverity, setAlertSeverity] = useState('success');
    const user = useSelector(state => state.state.user);

    // Локальное состояние для изменений
    const [localChanges, setLocalChanges] = useState({});

    // Состояние для отслеживания изменений спецификации
    const [pendingSpecChange, setPendingSpecChange] = useState(null);
    const [tempSpec, setTempSpec] = useState(null);

    // Получаем тип объекта для селектора задач
    const getObjectType = () => {
        if (mark.type.includes('pillar')) {
            return 'pillars';
        }
        return mark.type;
    };

    const objectType = getObjectType();
    const objectId = mark.fid;

    // Получаем задачу через селектор
    const task = useSelector(state => selectTasksByObject(state, objectType, objectId));



    // Инициализируем значение таба после загрузки данных
    useEffect(() => {
        if (!mark?.type || !tabs[mark.type]) return;

        // Получаем доступные табы
        const availableTabs = Object.entries(tabs[mark.type]).filter(([key, title]) => {
            if (key == 0 && !accountings?.length > 0) return false;
            if (key == 1 && (!images || images.length === 0)) return false;
            if (key == 3 && (!mounted || mounted.length === 0)) return false;
            if (key == 5 && !task) return false; // Вкладка "Задача" доступна только если есть задача
            return true;
        });
        console.log(availableTabs)
        if (availableTabs.length === 0) return;

        // Если значение еще не установлено, проверяем задачу
        if (value === null) {
            // Если задача не завершена, открываем вкладку "Задача" первой
            const taskTab = availableTabs.find(([key]) => key == 5);
            if (taskTab && task) {
                const taskStatus = task.statusCurrent || task.status;
                if (taskStatus !== 'done' && taskStatus !== 'cancelled') {
                    setValue('5');
                    valueRef.current = '5';
                    return;
                }
            }

            // Иначе устанавливаем первый доступный таб
            const firstAvailableTab = availableTabs[0][0];
            setValue(firstAvailableTab);
            valueRef.current = firstAvailableTab;
            return;
        }

        // Проверяем, доступен ли текущий таб
        const isCurrentTabAvailable = availableTabs.some(([key]) => key === value);

        // Если текущий таб недоступен, устанавливаем первый доступный
        if (!isCurrentTabAvailable) {
            const firstAvailableTab = availableTabs[0][0];
            setValue(firstAvailableTab);
            valueRef.current = firstAvailableTab;
        }
    }, [mark?.type, accountings, images, mounted, value, task]);

    // Обновляем локальное состояние при изменении accountings
    useEffect(() => {
        if (accountings) {
            console.log('Accountings updated:', accountings);
            console.log('First accounting structure:', accountings[0]);
        }
    }, [accountings]);

    // Права на редактирование
    const [canEditReady, canEditSuccess] = useMemo(() => {
        const ready = user.roles.some(v => ['project_manager', 'smr_foreman'].includes(v));
        const success = user.roles.includes('authors_control');
        console.log('User roles:', user.roles, 'canEditReady:', ready, 'canEditSuccess:', success);
        return [ready, success];
    }, [user]);

    // Права на редактирование спецификации
    const canEditSpec = useMemo(() => {
        return user.roles.includes('editor');
    }, [user]);

    // Функции для работы с алертами
    const showAlert = (message, severity = 'success') => {
        setAlertMessage(message);
        setAlertSeverity(severity);
        setAlertOpen(true);
    };

    const handleAlertClose = () => {
        setAlertOpen(false);
    };

    // Функция для получения полевых работ по опоре
    const fetchFieldWorks = async (pillarId) => {
        try {
            const response = await $authHost.get(`/apig/field-works`, {
                params: {
                    pillar: pillarId
                },
                headers: {
                    Authorization: `Bearer ${auth.user.access_token}`
                }
            });
            return response.data.data || [];
        } catch (error) {
            console.error('Ошибка получения полевых работ:', error);
            return [];
        }
    };

    // Функция для получения превью изображения
    const fetchImagePreview = async (s3Id) => {
        try {
            const response = await $authHost.get(`/apig/s3/files/${s3Id}/preview`, {
                headers: {
                    Authorization: `Bearer ${auth.user.access_token}`
                }
            });
            return response.data;
        } catch (error) {
            console.error('Ошибка получения превью изображения:', error);
            return null;
        }
    };

    // Функция для получения URL stream изображения
    const getStreamImageUrl = (s3Id) => {
        const token = auth.user?.access_token;
        if (!token) return null;

        // Формируем URL с токеном в query параметре для stream endpoint
        return `${$authHost.defaults.baseURL}/apig/s3/files/${s3Id}/stream?token=${encodeURIComponent(token)}`;
    };

    // Функция для загрузки изображений из полевых работ
    const loadImagesFromFieldWorks = async (pillarId) => {
        setLoadingImages(true);
        try {
            // Получаем полевые работы для опоры
            const fieldWorks = await fetchFieldWorks(pillarId);

            // Собираем все s3_files id из полевых работ
            const s3Files = [];
            fieldWorks.forEach(work => {
                if (work.files && Array.isArray(work.files)) {
                    s3Files.push(...work.files);
                }
            });

            if (s3Files.length === 0) {
                setImages([]);
                return;
            }
            console.log(s3Files)
            // Получаем превью для каждого изображения
            const imagePromises = s3Files.map(async (file) => {
                const previewData = await fetchImagePreview(file.id);
                if (previewData && previewData.success) {
                    return {
                        id: file.id,
                        preview: `data:${previewData.data.content_type};base64,${previewData.data.base64}`,
                        name: previewData.data.name,
                        user: previewData.data.user,
                        s3Id: file.id
                    };
                }
                return null;
            });

            const imagesData = await Promise.all(imagePromises);
            const validImages = imagesData.filter(img => img !== null);

            setImages(validImages);
        } catch (error) {
            console.error('Ошибка загрузки изображений:', error);
            setImages([]);
        } finally {
            setLoadingImages(false);
        }
    };

    // Функция для обработки изменений чекбоксов
    const handleCheckboxChange = useCallback((acc, checklistCode, type, checked) => {
        console.log('handleCheckboxChange called', {
            acc: acc,
            checklistCode: checklistCode,
            type: type,
            checked: checked,
            part_elimin_categ: acc.part_elimin_categ,
            acc_id: acc.id
        });

        // Получаем текущее состояние с учетом локальных изменений
        const localChange = localChanges[acc.id];
        const currentPartEliminCateg = localChange?.part_elimin_categ || acc.part_elimin_categ || { ready: [], success: [], rejected: [] };

        const newChecklistElim = {
            ready: [...(currentPartEliminCateg.ready || [])],
            success: [...(currentPartEliminCateg.success || [])],
            rejected: [...(currentPartEliminCateg.rejected || [])],
        };

        let defStatus = null;
        let newStatus = null;

        if (type === 'ready') {
            const isReady = newChecklistElim.ready.includes(checklistCode);
            const isRejected = newChecklistElim.rejected.includes(checklistCode);

            if (isReady) { // ready -> rejected
                newChecklistElim.ready = newChecklistElim.ready.filter(c => c !== checklistCode);
                newChecklistElim.rejected.push(checklistCode);
                newStatus = 'rejected';
            } else if (isRejected) { // rejected -> unchecked
                newChecklistElim.rejected = newChecklistElim.rejected.filter(c => c !== checklistCode);
                newStatus = null;
            } else { // unchecked -> ready
                newChecklistElim.ready.push(checklistCode);
                newStatus = 'ready';
            }

            // Определяем исходное состояние
            if (currentPartEliminCateg.ready?.includes(checklistCode)) {
                defStatus = 'ready';
            } else if (currentPartEliminCateg.rejected?.includes(checklistCode)) {
                defStatus = 'rejected';
            } else {
                defStatus = null;
            }
        } else if (type === 'success') {
            const isSuccess = newChecklistElim.success.includes(checklistCode);
            if (checked) { // becomes success
                if (!isSuccess) newChecklistElim.success.push(checklistCode);
                newStatus = 'success';
            } else { // becomes unchecked
                newChecklistElim.success = newChecklistElim.success.filter(c => c !== checklistCode);
                newStatus = null;
            }

            // Определяем исходное состояние
            if (currentPartEliminCateg.success?.includes(checklistCode)) {
                defStatus = 'success';
            } else {
                defStatus = null;
            }
        }

        // Обновляем локальное состояние для мгновенного отображения изменений
        setLocalChanges(prev => ({
            ...prev,
            [acc.id]: {
                ...prev[acc.id],
                part_elimin_categ: newChecklistElim
            }
        }));

        // Обновляем editedRowsRef для сохранения
        if (defStatus !== newStatus) {
            if (!editedRowsRef.current[acc.id]) {
                editedRowsRef.current[acc.id] = {};
            }

            editedRowsRef.current[acc.id].part_elimin_categ_def = acc.part_elimin_categ;
            editedRowsRef.current[acc.id].part_elimin_categ = newChecklistElim;
            editedRowsRef.current[acc.id].checklist = acc.checklist;
            editedRowsRef.current[acc.id].status_def = acc.status;
            editedRowsRef.current[acc.id].status_log = {
                ...editedRowsRef.current[acc.id].status_log,
                ...(acc.status_log || {}),
                [checklistCode]: {
                    ready: newStatus === 'ready',
                    success: newStatus === 'success',
                    rejected: newStatus === 'rejected',
                    dt: new Date().getTime(),
                    userid: user.vio_id,
                    reason: newStatus === 'rejected' && rejectionReason?.length > 0 ? rejectionReason : ''
                }
            };

            // Проверяем есть ли отклоненные элементы
            const rejectedCodes = newChecklistElim.rejected?.filter(r => !currentPartEliminCateg.rejected?.includes(r)) || [];
            setHasRejectedRows(rejectedCodes.length > 0);
        } else {
            // Проверяем нужно ли удалить из editedRowsRef
            const defPartElimin = currentPartEliminCateg;
            if ((defPartElimin?.ready || []).every(c => newChecklistElim.ready?.includes(c)) &&
                (newChecklistElim?.ready || []).every(c => defPartElimin.ready?.includes(c)) &&
                (defPartElimin?.success || []).every(c => newChecklistElim.success?.includes(c)) &&
                (newChecklistElim?.success || []).every(c => defPartElimin.success?.includes(c)) &&
                (defPartElimin?.rejected || []).every(c => newChecklistElim.rejected?.includes(c)) &&
                (newChecklistElim?.rejected || []).every(c => defPartElimin.rejected?.includes(c))
            ) {
                delete editedRowsRef.current[acc.id];
            }
        }

        // Обновляем состояние
        setEditedRows({ ...editedRowsRef.current });
    }, [user, rejectionReason, localChanges]);

    // Функция для сохранения изменений
    const handleSaveChanges = () => {
        const postChanges = async () => {
            if (!user.vio_id) {
                showAlert('Не задана привязка к VIO. Обратитесь к администратору.', 'error')
                return
            }
            showAlert('Отправка изменений на сервер...', 'info');
            try {
                const changes = []
                Object.entries(editedRows).map(([id, value]) => {
                    if (value.part_elimin_categ) changes.push({ id: id, field: 'part_elimin_categ', value: value.part_elimin_categ })
                    if (value.status_log) {
                        if (!hasRejectedRows) {
                            changes.push({ id: id, field: 'status_log', value: value.status_log })
                        } else {
                            const rejectedCodes = value.part_elimin_categ?.rejected?.filter(r => !value.part_elimin_categ_def?.rejected?.includes(r))
                            if (!rejectedCodes || rejectedCodes.length === 0) {
                                changes.push({ id: id, field: 'status_log', value: value.status_log })
                            } else {
                                const status_log_with_reason = JSON.parse(JSON.stringify(value.status_log || {}))
                                rejectedCodes.map(rc => {
                                    if (status_log_with_reason[rc] && !status_log_with_reason[rc].reason) {
                                        status_log_with_reason[rc] = {
                                            ...status_log_with_reason[rc],
                                            reason: rejectionReason
                                        }
                                    }
                                })
                                changes.push({ id: id, field: 'status_log', value: status_log_with_reason })
                            }
                        }
                    }

                    const defStatus = value.status_def
                    let newStatus = value.status_def

                    if (value.part_elimin_categ.success?.length === value.checklist.length) {
                        newStatus = 'Устранено'
                    } else if (value.part_elimin_categ.ready?.length === value.checklist.length) {
                        newStatus = 'Готово к проверке'
                    } else if (value.part_elimin_categ.rejected?.length === value.checklist.length) {
                        newStatus = 'Отклонено'
                    } else if (value.part_elimin_categ.success?.length === 0 && value.part_elimin_categ.ready?.length === 0 && value.part_elimin_categ.rejected?.length === 0) {
                        newStatus = 'Не устранено'
                    } else {
                        newStatus = 'Частично устранено'
                    }
                    if (defStatus !== newStatus) {
                        changes.push({ id: id, field: 'prescription_status', value: newStatus })
                    }
                })

                const response = await $authHost.post('/apig/state/accounting/part-elimin-categ', {
                    user_id: user.vio_id,
                    changes: changes
                }, {
                    timeout: 30000
                });

                if (response.status >= 200 && response.status < 300) {
                    setEditedRows({});
                    editedRowsRef.current = {}
                    setHasRejectedRows(false)
                    // Сбрасываем локальное состояние к исходным данным
                    if (accountings) {
                        setLocalChanges({});
                    }
                    dispatch(fetchAccounting())
                    showAlert('Изменения успешно сохранены!', 'success');
                } else {
                    showAlert('Произошла ошибка при сохранении. Попробуйте еще раз.', 'error');
                }
            } catch (error) {
                console.error('Ошибка при сохранении изменений:', error);
                if (error.response) {
                    const status = error.response.status;
                    if (status === 401) {
                        showAlert('Ошибка авторизации. Пожалуйста, перезайдите в систему.', 'error');
                    } else if (status === 403) {
                        showAlert('У вас нет прав для выполнения этого действия.', 'error');
                    } else {
                        showAlert('Ошибка сервера. Попробуйте позже.', 'error');
                    }
                } else {
                    showAlert('Сервер не отвечает. Проверьте подключение к интернету.', 'error');
                }
            }
        };
        postChanges();
    };

    // Функция для получения актуального статуса с учетом локальных изменений
    const getCurrentStatus = useCallback((acc) => {
        const localChange = localChanges[acc.id];
        if (!localChange) {
            // Если нет локальных изменений, используем исходный статус
            if (!mark.status.includes('approved')) {
                if (acc.status && Object.keys(translate).includes(acc.status)) {
                    return statuses[translate[acc.status]]
                }
            } else {
                return {
                    color: 'var(--accounting_approved)',
                    text: 'Согласовано'
                }
            }
            return null;
        }

        // Если есть локальные изменения, вычисляем новый статус
        const part_elimin_categ = localChange.part_elimin_categ || acc.part_elimin_categ || { ready: [], success: [], rejected: [] };

        if (part_elimin_categ.success?.length === acc.checklist?.length) {
            return statuses[translate['Устранено']] || { color: '#48B349', text: 'Устранено' };
        } else if (part_elimin_categ.ready?.length === acc.checklist?.length) {
            return statuses[translate['Готово к проверке']] || { color: '#2196F3', text: 'Готово к проверке' };
        } else if (part_elimin_categ.rejected?.length === acc.checklist?.length) {
            return statuses[translate['Отклонено']] || { color: '#9C27B0', text: 'Отклонено' };
        } else if (part_elimin_categ.success?.length === 0 && part_elimin_categ.ready?.length === 0 && part_elimin_categ.rejected?.length === 0) {
            return statuses[translate['Не устранено']] || { color: '#f44336', text: 'Не устранено' };
        } else {
            return statuses[translate['Частично устранено']] || { color: '#ff9800', text: 'Частично устранено' };
        }
    }, [localChanges, mark.status, translate]);

    // Функция для отмены изменений
    const handleCancelChanges = () => {
        setEditedRows({});
        editedRowsRef.current = {}
        setHasRejectedRows(false)
        // Сбрасываем локальное состояние к исходным данным
        setLocalChanges({});
        showAlert('Изменения отменены', 'warning');
    };

    // Добавляем глобальные стили для popup
    useEffect(() => {
        const style = document.createElement('style')
        style.textContent = `
            .leaflet-popup-content p {
                margin: 0 !important;
            }
        `
        document.head.appendChild(style)

        return () => {
            document.head.removeChild(style)
        }
    }, [])

    useEffect(() => {
        if (mark.type.includes('pillar')) {
            setType('pillars')
        } else {
            setType(mark.type)
        }

    }, [mark])

    const mountedSpecs = useMemo(() => {
        if (!mounted || !specs || !type) return null
        return mounted.map(m => specs[type].find(s => s.id === m.spec))
    }, [mounted, specs, type])

    // useEffect(() => {
    //     if (valueRef.current) setValue(valueRef.current)
    // }, [valueRef.current])

    const materialMapping = {
        '1': 'Дерево',
        '2': 'Железобетон',
        '3': 'Сталь'
    }

    // useEffect(() => {
    //     if (specs && mark.spec && type) {
    //         setSpec(specs[type].find(s => s.id === mark.spec))
    //     } else {
    //         setSpec(null)
    //     }
    // }, [specs, mark, type])

    useEffect(() => {
        // Не обновляем spec если есть незавершенные изменения
        if (pendingSpecChange) return;

        if (specs_new && mark.spec && specs_new[mark.spec] && type) {
            if (mark.spec_complect) {
                setSpec(specs_new[mark.spec]?.[Number(mark.spec_complect)])
            } else {
                setSpec(Object.values(specs_new[mark.spec])[0])
            }
        } else {
            setSpec(null)
        }
    }, [specs_new, mark, type, pendingSpecChange])

    // Функция для обновления спецификации опоры (только локальное изменение)
    const handleSpecChange = (newSpecId) => {
        // Сохраняем исходный spec для возможности отмены (только при первом изменении)
        // Используем null как маркер, что изменения есть (даже если изначально spec не был задан)
        if (pendingSpecChange == null) {
            setPendingSpecChange(mark.spec || null);
        }

        // Обновляем локальное состояние для отображения новой спецификации
        if (specs_new && specs_new[newSpecId] && type) {
            const newSpec = Object.values(specs_new[newSpecId])[0];
            setTempSpec(newSpec);
        }
    };

    // Функция для сохранения изменений спецификации
    const handleSaveSpecChange = async () => {
        // Проверяем наличие изменений: либо есть tempSpec, либо pendingSpecChange установлен
        if (!tempSpec && pendingSpecChange == null) return;

        try {
            showAlert('Сохранение изменений спецификации...', 'info');

            // Обновляем спецификацию через новый endpoint
            const response = await $authHost.post(`/apig/gisdb/updatespec`, {
                id: mark.fid,
                type: type,
                spec: tempSpec?.id || mark.spec
            });

            if (response.status >= 200 && response.status < 300 && response.data?.success) {
                // Обновляем mark.spec
                const savedSpecId = tempSpec?.id || mark.spec;
                mark.spec = savedSpecId;

                // Обновляем spec из tempSpec
                if (tempSpec) {
                    setSpec(tempSpec);
                }

                // Сбрасываем состояние изменений
                setPendingSpecChange(null);
                setTempSpec(null);

                // Перезагружаем mounted данные
                if (type) {
                    $authHost.get(`/apig/execution/${type}/${mark.fid}/history`).then(res => {
                        setMounted(res.data.data)
                    }).catch(err => {
                        console.log(`Get mounted for pillar ${mark.fid} error`, err)
                        setMounted(null)
                    })
                }

                showAlert('Спецификация успешно сохранена!', 'success');

                // Обновляем данные опоры в store
                dispatch(fetchAccounting());
            } else {
                const errorMessage = response.data?.error || 'Произошла ошибка при сохранении спецификации.';
                showAlert(errorMessage, 'error');
            }
        } catch (error) {
            console.error('Ошибка при сохранении спецификации:', error);
            if (error.response) {
                const status = error.response.status;
                const errorMessage = error.response.data?.error || 'Ошибка сервера';
                if (status === 401) {
                    showAlert('Ошибка авторизации. Пожалуйста, перезайдите в систему.', 'error');
                } else if (status === 403) {
                    showAlert('У вас нет прав для выполнения этого действия.', 'error');
                } else if (status === 400) {
                    showAlert(errorMessage, 'error');
                } else {
                    showAlert('Ошибка сервера. Попробуйте позже.', 'error');
                }
            } else {
                showAlert('Сервер не отвечает. Проверьте подключение к интернету.', 'error');
            }
        }
    };

    // Функция для отмены изменений спецификации
    const handleCancelSpecChange = () => {
        // Проверяем наличие изменений
        if (pendingSpecChange == null && !tempSpec) return;

        // Восстанавливаем исходную спецификацию
        if (pendingSpecChange != null && specs_new && specs_new[pendingSpecChange] && type) {
            const originalSpec = Object.values(specs_new[pendingSpecChange])[0];
            setSpec(originalSpec);
        } else {
            // Если изначально не было спецификации, просто сбрасываем
            setSpec(null);
        }

        // Сбрасываем состояние изменений
        setPendingSpecChange(null);
        setTempSpec(null);

        showAlert('Изменения спецификации отменены', 'warning');
    };



    useEffect(() => {
        if (!type) return
        $authHost.get(`/apig/execution/${type}/${mark.fid}/history`).then(res => {
            setMounted(res.data.data)
        }).catch(err => {
            console.log(`Get mounted for pillar ${mark.fid} error`, err)
            setMounted(null)
        })
    }, [mark, type])



    const tabs = {
        'pillar04': { 0: 'Предписания', 1: 'Фотоальбом', 2: 'Спецификация', 3: 'Монтаж', 4: 'Связанные объекты', 5: 'Задача' },
        'pillar10': { 0: 'Предписания', 1: 'Фотоальбом', 2: 'Спецификация', 3: 'Монтаж', 4: 'Связанные объекты', 5: 'Задача' },
        'pillar04-10': { 0: 'Предписания', 1: 'Фотоальбом', 2: 'Спецификация', 3: 'Монтаж', 4: 'Связанные объекты', 5: 'Задача' },
        'pillar04_10': { 0: 'Предписания', 1: 'Фотоальбом', 2: 'Спецификация', 3: 'Монтаж', 4: 'Связанные объекты', 5: 'Задача' },
        'opn': { 2: 'Спецификация', 3: 'Монтаж', 5: 'Задача' },
        'zvz': { 2: 'Спецификация', 3: 'Монтаж', 5: 'Задача' },
        'rlnd': { 2: 'Спецификация', 3: 'Монтаж', 5: 'Задача' },
        'runn': { 2: 'Спецификация', 3: 'Монтаж' }
    }

    function selectHost(host, layer = null) {
        map.fire('popupclose')
        if (host) {
            if (host.coords) {
                map.flyTo(host.coords, 18, { duration: 1, animate: false })
            } else if (host.bounds) {
                map.flyToBounds(host.bounds, 18, { duration: 1, animate: false })
            } else {
                map.flyTo([
                    host.x_y_coord.split(' ')[1],
                    host.x_y_coord.split(' ')[0],
                ], 16, { duration: 1, animate: false })
            }

            map.eachLayer(function (layer) {
                layer.closeTooltip()
            })

            dispatch(setLayers([
                { layer: 'transformers', position: 1 },
                { layer: 'pillars04', position: 1 },
                { layer: 'pillars04_10', position: 1 },
                { layer: 'pillars10', position: 1 },
                { layer: 'fiders04', position: 1 },
                { layer: 'fiders04_10', position: 1 },
                { layer: 'fiders10', position: 1 },
            ]))

            setTimeout(() => {
                map.closePopup()
                map.eachLayer(function (layer) {
                    if (layer.options.data === host.fid || layer.options.data === host.id) {
                        layer.openTooltip()
                        addPulseMarker(map, layer)
                    }
                })
            }, 500)
        }
    }


    function getContent() {
        return (
            <Paper elevation={0} sx={{ bgcolor: 'background.paper' }}>
                <Tabs
                    value={value || false}
                    onChange={handleTabChange}
                    textColor="primary"
                    indicatorColor="primary"
                    variant="scrollable"
                    sx={{
                        minHeight: { xs: 20, sm: 30 },
                        '& .MuiTab-root': {
                            minHeight: { xs: 20, sm: 30 },
                            py: { xs: 0.2, sm: 0.5 },
                            fontSize: { xs: '0.7rem', sm: '0.75rem' },
                            fontWeight: 600
                        }
                    }}
                >
                    {Object.entries(tabs[mark.type]).map(([key, title]) => {
                        if (key == 0 && !accountings?.length > 0) return null
                        if (key == 1 && (!images || images.length === 0)) return null
                        if (key == 3 && (!mounted || mounted.length === 0)) return null
                        if (key == 5 && !task) return null
                        return <Tab key={key} value={key} label={title} />
                    })}
                </Tabs>

                <TabPanel key={0} value={value} index={0} >
                    {accountings?.length > 0 ?
                        <Box sx={{ maxHeight: '300px', overflowY: 'auto', scrollbarWidth: 'thin' }}>
                            <TableContainer component={Paper} sx={{
                                boxShadow: 'none',
                                fontSize: { xs: '10px', sm: '12px' },

                                '& .MuiTableCell-root': {
                                    border: '1px solid #e0e0e0',
                                    padding: '3px 3px',
                                    verticalAlign: 'middle',
                                    lineHeight: 0.9,
                                    backgroundColor: 'unset'
                                },
                                '& .MuiTableHead-root .MuiTableCell-root': {
                                    fontSize: { xs: '12px', sm: '14px' },
                                    backgroundColor: '#5ca4cd',
                                    color: 'white',
                                    zIndex: 2,
                                    padding: '3px 0',
                                    fontWeight: 'bold',
                                    textAlign: 'center'
                                },
                                '& .MuiTableBody-root .MuiTableRow-root:nth-child(even)': {
                                    backgroundColor: '#e1f9ff'

                                }
                            }}>
                                <Table size="small" aria-label="a dense table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ borderTopLeftRadius: '5px', width: '10%' }}>№</TableCell>
                                            <TableCell sx={{ width: '50%' }}>Предписание</TableCell>
                                            <TableCell sx={{ width: '20%' }}>Отметка о выполнении</TableCell>
                                            <TableCell sx={{ borderTopRightRadius: '5px', width: '20%' }}>Авторский надзор</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {accountings.map((acc, i) => {
                                            console.log(mark.status)
                                            const status = getCurrentStatus(acc);

                                            if (!status) return null
                                            let color = status.color
                                            let icon = status.icon
                                            return (
                                                <TableRow key={acc.id || i}>
                                                    <TableCell sx={{
                                                        textAlign: 'center',
                                                        verticalAlign: 'middle',
                                                        padding: '3px 3px',
                                                        lineHeight: 0.9
                                                    }}>
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                                                            <svg width={10} height={10} viewBox="0 0 100 100" style={{ margin: '2px 0' }}>
                                                                <circle r="50" cx="50" cy="50" fill={color} />
                                                            </svg>
                                                            <Typography variant="body2" sx={{
                                                                fontSize: { xs: '10px', sm: '12px' },
                                                                lineHeight: 1
                                                            }}>
                                                                {acc.id}
                                                            </Typography>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        padding: '3px 3px',
                                                        lineHeight: 0.9
                                                    }}>
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
                                                            {acc.checklist ? acc.checklist.map((c, i) => {
                                                                const rule = rulesMap[c]
                                                                if (!rule) return null;

                                                                // Используем локальные изменения или исходные данные
                                                                const localChange = localChanges[acc.id];
                                                                const part_elimin_categ = localChange?.part_elimin_categ || acc.part_elimin_categ || { ready: [], success: [], rejected: [] };
                                                                const isReadyChecked = part_elimin_categ.ready?.includes(c) || false;
                                                                const isRejected = part_elimin_categ.rejected?.includes(c) || false;
                                                                const isSuccessChecked = part_elimin_categ.success?.includes(c) || false;
                                                                const statusLog = localChange?.status_log?.[c] || acc.status_log?.[c];
                                                                const _statusLog = acc._status_log?.[c];

                                                                console.log('Checkbox states:', {
                                                                    c,
                                                                    isReadyChecked,
                                                                    isRejected,
                                                                    isSuccessChecked,
                                                                    part_elimin_categ,
                                                                    statusLog,
                                                                    _statusLog
                                                                });
                                                                return (
                                                                    <Box key={`${acc.id}_checklist_${i}`} sx={{
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        alignItems: 'flex-start',
                                                                        gap: 0,
                                                                        width: '100%'
                                                                    }}>
                                                                        {/* Информация о статусе */}
                                                                        {(statusLog?.ready || statusLog?.rejected) && (
                                                                            <Typography
                                                                                sx={{
                                                                                    fontSize: '0.6rem',
                                                                                    color: statusLog?.rejected ? '#9C27B0' : '#2196F3'
                                                                                }}
                                                                            >
                                                                                {_statusLog?.date} {_statusLog?.user?.short_fio} ({_statusLog?.user?.post_for_select})
                                                                                {/* {statusLog?.reason ? statusLog?.reason : ''} */}
                                                                            </Typography>
                                                                        )}

                                                                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 0.5, width: '100%' }}>
                                                                            <Checkbox
                                                                                checked={isReadyChecked}
                                                                                indeterminate={isRejected}
                                                                                disabled={!canEditReady || isSuccessChecked}
                                                                                onClick={(e) => {
                                                                                    handleCheckboxChange(acc, c, 'ready');

                                                                                    e.stopPropagation();
                                                                                }}
                                                                                // onChange={(e) => {
                                                                                //     console.log('onChange ready checkbox', { acc, c })
                                                                                //     handleCheckboxChange(acc, c, 'ready')
                                                                                //     e.stopPropagation()
                                                                                // }}
                                                                                size="small"
                                                                                indeterminateIcon={
                                                                                    <Box sx={{ position: 'relative' }}>
                                                                                        <svg width={'1.2rem'} height={'1.2rem'} className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CheckBoxOutlineBlankIcon">
                                                                                            <rect x="3" y="3" width="18" height="18" rx="2" />
                                                                                            <line x1="7" y1="7" x2="17" y2="17" stroke="white" strokeWidth="2" />
                                                                                            <line x1="17" y1="7" x2="7" y2="17" stroke="white" strokeWidth="2" />
                                                                                        </svg>
                                                                                    </Box>
                                                                                }
                                                                                sx={{
                                                                                    padding: 0,
                                                                                    color: isRejected ? '#9C27B0' : '#2196F3',
                                                                                    '& .MuiSvgIcon-root': { fill: isRejected ? '#9C27B0' : '#2196F3' },
                                                                                    '&.Mui-disabled': { opacity: 0.5 }
                                                                                }}
                                                                            />
                                                                            <Checkbox
                                                                                checked={isSuccessChecked}
                                                                                disabled={!canEditSuccess}
                                                                                onClick={(e) => {
                                                                                    handleCheckboxChange(acc, c, 'success', !isSuccessChecked);

                                                                                    e.stopPropagation();
                                                                                }}
                                                                                // onChange={(e) => {
                                                                                //     console.log('onChange success checkbox', { acc, c, checked: e.target.checked })
                                                                                //     handleCheckboxChange(acc, c, 'success', e.target.checked)
                                                                                // }}
                                                                                size="small"
                                                                                sx={{
                                                                                    padding: 0,
                                                                                    color: `#48B349`,
                                                                                    '& .MuiSvgIcon-root': { fill: `#48B349` },
                                                                                    '&.Mui-disabled': { opacity: 0.5 }
                                                                                }}
                                                                            />
                                                                            <Typography
                                                                                variant="body2"
                                                                                sx={{
                                                                                    fontWeight: 'bold',
                                                                                    color: `rgb(${codeColors[c[0]] || [0, 0, 0]})`,
                                                                                    fontSize: { xs: '10px', sm: '12px' },
                                                                                    lineHeight: 0.9
                                                                                }}
                                                                            >
                                                                                {rule.code}
                                                                            </Typography>
                                                                            <Typography
                                                                                variant="body2"
                                                                                sx={{
                                                                                    marginLeft: '5px',
                                                                                    fontWeight: isSuccessChecked || isReadyChecked || isRejected ? 'bold' : 'normal',
                                                                                    color: isSuccessChecked ? `#48B349` : isReadyChecked ? `#2196F3` : isRejected ? '#9C27B0' : "inherit",
                                                                                    fontSize: { xs: '10px', sm: '12px' },
                                                                                    lineHeight: 0.9
                                                                                }}
                                                                            >
                                                                                {rule.name}
                                                                            </Typography>

                                                                            {/* Причина отклонения */}
                                                                            {isRejected && statusLog?.reason && (
                                                                                <Typography
                                                                                    sx={{
                                                                                        fontSize: '0.6rem',
                                                                                        color: '#9C27B0',
                                                                                        fontStyle: 'italic'
                                                                                    }}
                                                                                >
                                                                                    ({statusLog.reason})
                                                                                </Typography>
                                                                            )}
                                                                        </Box>

                                                                        {/* Информация о success статусе */}
                                                                        {statusLog?.success && (
                                                                            <Typography
                                                                                sx={{
                                                                                    fontSize: '0.6rem',
                                                                                    color: '#48B349'
                                                                                }}
                                                                            >
                                                                                {_statusLog?.date} {_statusLog?.user?.short_fio} ({_statusLog?.user?.post_for_select})
                                                                            </Typography>
                                                                        )}
                                                                    </Box>
                                                                )
                                                            }) : (
                                                                <Typography variant="body2" sx={{
                                                                    fontSize: { xs: '10px', sm: '12px' },
                                                                    lineHeight: 0.9
                                                                }}>
                                                                    {mark.status.includes('approved') ? acc.retreat_psd : acc.instructions}
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        textAlign: 'center',
                                                        verticalAlign: 'middle',
                                                        padding: '3px 3px',
                                                        lineHeight: 0.9
                                                    }}>
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    color: color,
                                                                    fontWeight: 'bold',
                                                                    fontSize: { xs: '10px', sm: '12px' },
                                                                    lineHeight: 0.9
                                                                }}
                                                            >
                                                                {status.text}
                                                            </Typography>
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    fontSize: { xs: '10px', sm: '12px' },
                                                                    lineHeight: 0.9
                                                                }}
                                                            >
                                                                {acc.status_date}
                                                            </Typography>
                                                            {/* <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    fontSize: { xs: '10px', sm: '12px' },
                                                                    lineHeight: 0.9
                                                                }}
                                                            >
                                                                {acc.mark_completion_editor?.for_select || ''}
                                                            </Typography> */}
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        textAlign: 'center',
                                                        verticalAlign: 'middle',
                                                        padding: '3px 3px',
                                                        lineHeight: 0.9
                                                    }}>
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    fontSize: { xs: '10px', sm: '12px' },
                                                                    lineHeight: 0.9
                                                                }}
                                                            >
                                                                {acc.created}
                                                            </Typography>
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    fontSize: { xs: '10px', sm: '12px' },
                                                                    lineHeight: 0.9
                                                                }}
                                                            >
                                                                {acc.creator.short_fio} ({acc.creator.post_for_select})
                                                            </Typography>
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                        : null}
                </TabPanel>

                <TabPanel key={1} value={value} index={1}>
                    <ImagesTab
                        images={images}
                        darkMode={false}
                    />
                </TabPanel>
                <TabPanel key={2} value={value} index={2}>
                    <SpecsTab
                        spec={tempSpec || spec}
                        saveToStorage={saveToStorage}
                        STORAGE_KEYS={STORAGE_KEYS}
                        darkMode={false}
                        specs={specs}
                        type={type}
                        mark={mark}
                        onSpecChange={handleSpecChange}
                        canEdit={canEditSpec}
                    />
                </TabPanel>
                <TabPanel key={3} value={value} index={3}>
                    <MountedTab
                        mark={mark}
                        mounted={mounted}
                        mountedSpecs={mountedSpecs}
                        spec={spec}
                        darkMode={false}
                    />
                </TabPanel>
                <TabPanel key={4} value={value} index={4}>
                    <RelatedObjectsPanel mark={mark} darkMode={false} />
                </TabPanel>
                <TabPanel key={5} value={value} index={5}>
                    <TaskTab
                        mark={mark}
                        darkMode={false}
                        map={map}
                    />
                </TabPanel>
            </Paper>
        )
    }



    // Snackbar для алертов
    return (
        <>
            {createPortal(
                <Popup
                    position={mark.coords}
                    key={`pillar_${mark.fid}`}
                    maxWidth={window.innerWidth < 768 ? 350 : 700}
                    style={{

                    }}
                    autoClose={false}
                    offset={[0, 3]}
                    className="pillar-popup"
                    eventHandlers={{
                        add: (p) => {
                            loadImagesFromFieldWorks(mark.fid);
                        },
                        remove: (p) => {
                            map.fire('popupclose')
                        }
                    }}
                >
                    <Paper elevation={0} sx={{
                        m: 0,
                        p: 0,
                        bgcolor: 'transparent'
                    }}>
                        {/* Заголовок */}
                        <Card variant="outlined" sx={{ mb: 0.5 }}>
                            <CardContent sx={{ p: 0.2, textAlign: 'center', '&:last-child': { pb: 0.2 } }}>
                                <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                                    {/* <TowerIcon sx={{ fontSize: 20, color: 'primary.main' }} /> */}


                                    <Typography variant="subtitle2" fontWeight="600" color="primary.main" sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}>
                                        {types[mark.type]}: {mark.name ? mark.name : mark.closest_pillar_id ? pillars.find(p => p.fid.toString() === mark.closest_pillar_id)?.name : ''}
                                    </Typography>
                                </Stack>
                            </CardContent>
                        </Card>

                        {/* Основной контент */}
                        <Box sx={{ mb: 0.5 }}>
                            {getContent()}
                        </Box>

                        {/* Кнопки действий */}
                        <Stack direction="row" gap={1} justifyContent="space-between" alignItems="center" p={0.5} flexWrap="wrap">
                            <Stack direction="row" gap={1} flexWrap="wrap">
                                {mark.coords && (
                                    <Button
                                        variant="contained"
                                        size="small"
                                        startIcon={<PlaceIcon sx={{ fontSize: { xs: '0.7rem', sm: '0.75rem' } }} />}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            window.open(`https://yandex.ru/maps/?whatshere[point]=${mark.coords[1]},${mark.coords[0]}&whatshere[zoom]=17`);
                                        }}
                                        sx={{
                                            minWidth: 'auto',
                                            px: { xs: 1, sm: 1.5 },
                                            py: { xs: 0.2, sm: 0.3 },
                                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                        }}
                                    >
                                        Карта
                                    </Button>
                                )}
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    startIcon={<ShareIcon sx={{ fontSize: { xs: '0.7rem', sm: '0.75rem' } }} />}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        console.log(mark)
                                        const base64 = btoa(JSON.stringify({
                                            type: mark.type,
                                            id: mark.fid,
                                        }))
                                        navigator.clipboard.writeText(`${window.location.origin}/an?view=${encodeURIComponent(base64)}`)
                                        dispatch(addNotification({
                                            message: 'Ссылка на объект скопирована в буфер обмена',
                                            severity: 'success',
                                            autoHideDuration: 3000
                                        }))
                                    }}
                                    sx={{
                                        minWidth: 'auto',
                                        px: { xs: 1, sm: 1.5 },
                                        py: { xs: 0.2, sm: 0.3 },
                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                    }}
                                >
                                    Поделиться
                                </Button>
                            </Stack>

                            {/* Кнопки сохранения изменений спецификации */}
                            {(pendingSpecChange != null || tempSpec) && (
                                <Stack direction="row" spacing={1} flexWrap="wrap">
                                    <Button
                                        variant="contained"
                                        color="success"
                                        size="small"
                                        startIcon={<SaveIcon sx={{ fontSize: { xs: '0.7rem', sm: '0.75rem' } }} />}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            handleSaveSpecChange();
                                        }}
                                        sx={{
                                            minWidth: 'auto',
                                            px: { xs: 1, sm: 1.5 },
                                            py: { xs: 0.2, sm: 0.3 },
                                            fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                            backgroundColor: '#4caf50',
                                            '&:hover': {
                                                backgroundColor: '#45a049'
                                            }
                                        }}
                                    >
                                        Сохранить
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="error"
                                        size="small"
                                        startIcon={<CancelIcon sx={{ fontSize: { xs: '0.7rem', sm: '0.75rem' } }} />}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            handleCancelSpecChange();
                                        }}
                                        sx={{
                                            minWidth: 'auto',
                                            px: { xs: 1, sm: 1.5 },
                                            py: { xs: 0.2, sm: 0.3 },
                                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                        }}
                                    >
                                        Отмена
                                    </Button>
                                </Stack>
                            )}
                        </Stack>

                        {/* Кнопки сохранения изменений */}
                        {Object.keys(editedRows).length > 0 && (
                            <Stack direction="row" justifyContent={'flex-end'} spacing={1} sx={{ mt: 1, width: '100%' }}>
                                {/* Поле для причины отклонения */}
                                {hasRejectedRows && (
                                    <TextField
                                        multiline
                                        rows={2}
                                        placeholder="Введите обоснование отклонения..."
                                        value={rejectionReason}
                                        onChange={(e) => setRejectionReason(e.target.value)}
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            flex: 1,
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: '#9C27B0',
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: '#7B1FA2',
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: '#6A1B9A',
                                                },
                                            },
                                            '& .MuiInputBase-root': {
                                                fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                                padding: '4px 6px'
                                            }
                                        }}
                                    />
                                )}

                                <Button
                                    variant="contained"
                                    size="small"
                                    disabled={hasRejectedRows && !rejectionReason}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleSaveChanges()
                                    }}
                                    sx={{
                                        backgroundColor: '#4caf50',
                                        color: 'white',
                                        minWidth: 'auto',
                                        width: '40px',
                                        // height: '40px',
                                        minHeight: '25px',
                                        p: 0,
                                        '&:hover': {
                                            backgroundColor: '#45a049'
                                        },
                                        '&:disabled': {
                                            backgroundColor: '#cccccc',
                                            color: '#666666'
                                        }
                                    }}
                                >
                                    <SaveIcon sx={{ fontSize: { xs: '1rem', sm: '1.2rem' } }} />
                                </Button>
                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleCancelChanges()
                                    }}
                                    sx={{
                                        backgroundColor: '#f44336',
                                        color: 'white',
                                        minWidth: 'auto',
                                        width: '40px',
                                        // height: '40px',
                                        minHeight: '25px',
                                        p: 0,
                                        '&:hover': {
                                            backgroundColor: '#d32f2f'
                                        }
                                    }}
                                >
                                    <CancelIcon sx={{ fontSize: { xs: '1rem', sm: '1.2rem' } }} />
                                </Button>
                            </Stack>
                        )}
                    </Paper>
                </Popup>,
                document.getElementsByClassName('leaflet-pane leaflet-popup-pane')[0]
            )}

            {/* Snackbar для алертов */}
            <Snackbar
                open={alertOpen}
                autoHideDuration={6000}
                onClose={handleAlertClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                sx={{ zIndex: 10000 }}
            >
                <Alert
                    onClose={handleAlertClose}
                    severity={alertSeverity}
                    sx={{ width: '100%' }}
                    variant="filled"
                >
                    {alertMessage}
                </Alert>
            </Snackbar>
        </>
    )


}

export default PopupPillar04